<template>
  <div>
    <div class="flex gap-20 justify-between dropdowns-search">
      <div
          class="bordered dropdown flex items-center"
          :class="hide_pagination ? 'w-full' : (min_filter && !limit_width ? 'min_search' : (limit_width ? 'next_min_search w-7/12' : 'w-2/3'))"
          v-if="!isInPopup">
        <dropdown
            v-if="names.length > 1"
            id="company_names"
            class="pseudo-input text-left"
            :options="names"
            :selected="selected_name"
            :items_count="items_count"
            v-on:updateOption="selectSortFilterName"
        >
        </dropdown>
        <input v-else class="pseudo-input-no-drop text-left" v-model="selected_name.name" disabled type="text">
        <div class="search justify-between w-full flex px-4 items-center">
            <span class="search_input_span">
              <input class="search_input focus:outline-none" type="text" v-on:keyup.enter="searchItems" v-model="searchNames" placeholder="Search..">
            </span>
          <span class="icon" @click="searchItems">
              <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path d="M11 18C14.866 18 18 14.866 18 11C18 7.13401 14.866 4 11 4C7.13401 4 4 7.13401 4 11C4 14.866 7.13401 18 11 18Z" stroke="#1FBC2F" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/>
                <path d="M19 19L16 16" stroke="#1FBC2F" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/>
              </svg>
            </span>
        </div>
      </div>
      <div v-if="!hide_pagination" class="flex items-center justify-between gap-5p rows-count" :class="limit_width ? 'w-5/12' : 'w-1/3'">
        <div class="bordered dropdown flex items-center">
          <dropdown
              id="rows_per_page"
              class="pseudo-input"
              :options="rows_per_page"
              :selected="{name: defaultRowsCount().name, id: defaultRowsCount().id}"
              v-on:updateOption="selectRowsCount"
          />
        </div>
        <div class="flex mt-11 items-center justify-between nowrap paginator">
            <span>
              {{this.fromNumber}} - {{this.toNumber}} of {{ items_count }}
            </span>
          <span class="arrows flex items-center justify-between nowrap">
            <button type="button"
                    :disabled="disabledPrev"
                    @click="nextPrevRows('-')"
                    class="inline-flex text-grey-darker paginate">
            <svg width="5" height="8" viewBox="0 0 5 8" fill="none" xmlns="http://www.w3.org/2000/svg">
              <path d="M4 7L1 4L4 1" stroke="#1FBC2F" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/>
            </svg>
          </button>
            <button type="button"
                    :disabled="disabledNext"
                    @click="nextPrevRows()"
                    class="inline-flex text-grey-darker paginate">
            <svg width="5" height="8" viewBox="0 0 5 8" fill="none" xmlns="http://www.w3.org/2000/svg">
              <path d="M1 1L4 4L1 7" stroke="#1FBC2F" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/>
            </svg>
          </button>
          </span>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import dropdown from 'vue-dropdowns';
import {mapMutations, mapGetters} from "vuex";
export default {
  name: "Filters",
  props: {
    names: {
      type: Array
    },
    selected_name: {
      type: Object
    },
    items_count: {
      type: Number
    },
    rows_count: {
      type: Number,
      default: 10
    },
    isInPopup: {
      type: Boolean,
      default: false
    },
    useLocalState: {
      type: Boolean,
      default: false
    },
    min_filter: {
      type: Boolean,
      default: false
    },
    limit_width: {
      type: Boolean,
      default: false
    },
    hide_pagination: {
      type: Boolean,
      default: false
    }
  },
  data() {
    return {
      fromNumber: 1,
      toNumber: null,
      items_names:[],
      searchNames: null,
      default_rows_count: this.rows_count,
      disabledPrev: true,
      disabledNext: false,
      localItemsToShow: this.rows_count,
      localRowsToShift: 0,
      localSearchNames: '',
      localSelectedFilterItem: null,
      rows_per_page:[
        {
          name: '5 rows',
          id: 5
        },
        {
          name: '10 rows',
          id: 10
        },
        {
          name: '20 rows',
          id: 20
        },
        {
          name: '50 rows',
          id: 50
        },
        {
          name: '100 rows',
          id: 100
        }
      ]
    }
  },
  methods: {
    ...mapMutations([
      'setItemsToShow',
      'setSelectedFilterItem',
      'setRowsToShift',
      'setSearchItemsNames',
    ]),
    emitStateChange() {
      if (!this.useLocalState) {
        return;
      }
      this.$emit('state-change', {
        skip: this.localRowsToShift,
        take: this.localItemsToShow,
        search: this.localSearchNames || '',
        sortId: this.localSelectedFilterItem,
      });
    },
    async searchItems() {
      if (this.searchNames?.length >= 2 || !this.searchNames?.length) {
        if (this.useLocalState) {
          this.localSearchNames = this.searchNames || '';
          this.localRowsToShift = 0;
          this.fromNumber = 1;
          this.toNumber = Math.min(this.localItemsToShow, this.items_count || this.localItemsToShow);
          this.emitStateChange();
          return;
        }
        this.setSearchItemsNames(this.searchNames);
      }
    },
    async selectRowsCount(val) {
      if (this.useLocalState) {
        this.localItemsToShow = val.id;
        this.default_rows_count = val.id;
        this.toNumber = val.id;
        this.fromNumber = 1;
        this.localRowsToShift = 0;
        this.disabledNext = this.items_count <= val.id;
        this.disabledPrev = true;
        this.emitStateChange();
        return;
      }
      this.setItemsToShow(val.id);
      this.default_rows_count = val.id;
      this.toNumber = val.id;
      this.fromNumber = 1;
      this.setRowsToShift(0);
      if(this.items_count <= val.id) {
        this.disabledNext = true;
      } else {
        this.disabledNext = false;
      }
    },
    selectSortFilterName(val){
      if (this.useLocalState) {
        this.localSelectedFilterItem = val.id;
        this.emitStateChange();
        return;
      }
      this.setSelectedFilterItem(val.id)
    },
    async nextPrevRows(operator = '+') {
      switch(operator) {
        case '+':
          if ((this.toNumber + this.effectiveItemsToShow) > this.items_count) {
            this.toNumber = this.items_count;
            this.disabledNext = true;
          } else {
            this.toNumber = this.toNumber + this.effectiveItemsToShow;
          }
          this.disabledPrev = false;
          if ((this.fromNumber + this.effectiveItemsToShow) > this.items_count) {
            return;
          }
          this.fromNumber = this.fromNumber + this.effectiveItemsToShow;
          this.setEffectiveRowsToShift(this.fromNumber - 1);
          break;
        case '-':
          if(this.fromNumber == 1) {
            return;
          }
          this.disabledNext = false;
          if ((this.fromNumber - this.effectiveItemsToShow) == 1) {
            this.toNumber = this.effectiveItemsToShow;
            this.disabledPrev = true;
          } else {
            this.toNumber = this.toNumber - this.effectiveItemsToShow;
          }
          this.fromNumber = this.fromNumber - this.default_rows_count;
          this.toNumber = this.fromNumber + this.default_rows_count -1;
          this.setEffectiveRowsToShift(this.fromNumber - 1);
          break;
      }
    },
    setEffectiveRowsToShift(value) {
      if (this.useLocalState) {
        this.localRowsToShift = value;
        this.emitStateChange();
        return;
      }
      this.setRowsToShift(value);
    },
    defaultPaginator() {

    },
    defaultRowsCount(){
      return {name: this.default_rows_count + ' rows', id: this.default_rows_count};
    },
  },
  async mounted() {
    if (this.useLocalState) {
      this.localItemsToShow = this.default_rows_count;
      this.localRowsToShift = 0;
      this.localSelectedFilterItem = this.selected_name?.id || null;
      this.toNumber = Math.min(this.default_rows_count, this.items_count || this.default_rows_count);
      this.emitStateChange();
      return;
    }
    if (this.hide_pagination) {
      return;
    }
    await this.setItemsToShow(this.default_rows_count)
    await this.setSelectedFilterItem(this.selected_name?.id)
    await this.defaultPaginator()
  },
  computed: {
    ...mapGetters([
      'getItemsToShow',
      'getSelectedFilterItem',
      'getRowsToShift',
    ]),
    effectiveItemsToShow() {
      return this.useLocalState ? this.localItemsToShow : this.getItemsToShow;
    },
    effectiveRowsToShift() {
      return this.useLocalState ? this.localRowsToShift : this.getRowsToShift;
    },
  },
  watch: {
    items_count(val) {
      this.toNumber = this.default_rows_count;
      if (this.items_count <= this.default_rows_count) {
        this.toNumber = val
        this.disabledPrev = true;
        this.disabledNext = true;
      }
    }
  },
  components: {
    dropdown
  }
}
</script>

<style lang="scss" scoped>
.arrows {
  width: 50px;
  .paginate {
    padding: 5px;
    &:disabled {
      cursor: not-allowed;
      svg {
        path {
          stroke: #9ca3af!important;
        }
      }
    }
  }
}
.min_search {
  width: 584px;
}
.next_min_search {
  width: 400px;
}
.pseudo-input-no-drop {
  margin-left: 10px;
  color: #606f7b;
  border-right: 2px solid #E5E5E5;
  max-height: 24px;
  max-width: 158px;
  background: white;
  padding-left: 5px;
  overflow: hidden;
  -o-text-overflow: ellipsis;
  -ms-text-overflow: ellipsis;
  text-overflow: ellipsis;
}
.search_input_span {
  width: 100%;
}
.search_input {
  width: 100%;
  //&:hover, &:focus, &:active {
  //  border: none !important;
  //}
}
</style>
